module.exports = __webpack_public_path__ + "img/watcherPortrait.d5083530.jpg";